// Operational Reporting: the routes and the sidebar rows of `wealth.ops.reporting` (ADR-0027).
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.ops.reporting',
    routes: [
        { frontend: 'ops', path: 'reporting', lazy: () => import('@/pages/ops/reporting/page') },
        {
            frontend: 'ops',
            path: 'reporting/kpi-months',
            lazy: () => import('@/pages/ops/reporting/kpi-months/page'),
        },
    ],
    nav: [
        {
            frontend: 'ops',
            key: 'reporting',
            label: 'Reporting',
            href: '/ops/reporting',
            icon: 'FileBarChart',
            group: 'reporting',
            order: 510,
        },
    ],
});
